import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Checkbox } from 'rsuite';

// redux
import {
  getCampaignElementById,
  getHasTermsSignatureElement,
  updateCampaignElementCurrentLink,
  updateCampaignElementValue
} from '../../redux/modules/campaignLandingPage';
// styles
import styles from './CheckboxElement.module.less';
import crakIds from '../../constants/crak';

const CheckboxElement = ({
  _updateCampaignElementValue,
  _updateCampaignElementCurrentLink,
  element,
  qid,
  hasSignatureElement
}) => {
  const isShowingTermsSignatureElement =
    element.crakId === crakIds.TERMS_AND_CONDITIONS_INPUT && hasSignatureElement;

  useEffect(() => {
    _updateCampaignElementValue({ qid, selected: false });
  }, [qid]);
  const createMarkup = () => {
    return { __html: element.description };
  };
  const onChange = (e, selected) => {
    _updateCampaignElementValue({ qid, selected });
  };
  const onClick = ({ target }) => {
    // logic for opening modal on rich text link click
    const termsLink = target?.getAttribute('data-terms-link');
    if (termsLink) {
      _updateCampaignElementCurrentLink(termsLink);
    }
  };
  return (
    <section
      className={
        !isShowingTermsSignatureElement
          ? styles.vpCheckboxElementContainer
          : styles.vpCheckboxElementContainerHiddenCheck
      }
    >
      {!isShowingTermsSignatureElement && <Checkbox onChange={onChange} />}
      <section
        onClick={onClick}
        className={styles.vpCheckboxRichText}
        dangerouslySetInnerHTML={createMarkup()}
      />
    </section>
  );
};

CheckboxElement.propTypes = {
  _updateCampaignElementValue: PropTypes.func,
  _updateCampaignElementCurrentLink: PropTypes.func,
  qid: PropTypes.string,
  hasSignatureElement: PropTypes.bool,
  element: PropTypes.object
};

const mapStateToProps = (state, ownProps) => ({
  element: getCampaignElementById(state, ownProps.qid),
  hasSignatureElement: getHasTermsSignatureElement(state)
});

const mapDispatchToProps = {
  _updateCampaignElementValue: updateCampaignElementValue,
  _updateCampaignElementCurrentLink: updateCampaignElementCurrentLink
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxElement);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/CheckboxElement.jsx